
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// ================== 首页模块 ==================
const Index = () => import(/* webpackChunkName: "home" */ '@/pages/home/index'); // 首页

// ================== 登录模块 ==================
const Login = () => import(/* webpackChunkName: "login" */ '@/pages/login/login-index'); // 登录

// ================== 代理商管理模块 ==================
const AgentMessage = () => import(/* webpackChunkName: "agency" */ '@/pages/agency/agent-message'); // 代理商信息
const AddAgent = () => import(/* webpackChunkName: "agency" */ '@/pages/agency/add-agent'); // 新增代理商
const SettleChange = () => import(/* webpackChunkName: "agency" */ '@/pages/agency/settle-change'); // 代理商审核
const DeductionExamineAgent = () => import(/* webpackChunkName: "agency" */ '@/pages/agency/deductionExamine-agent'); // 加扣款审核
const AssociatedRecord = () => import(/* webpackChunkName: "agency" */ '@/pages/agency/associated-record'); // 代理商关联

// ================== 服务商管理模块 ==================
const ProviderMessage = () => import(/* webpackChunkName: "facilitator" */ '@/pages/facilitator/provider-message'); // 服务商信息
const AddProvider = () => import(/* webpackChunkName: "facilitator" */ '@/pages/facilitator/add-provider'); // 新增服务商

// ================== 认证管理模块 ==================
const PersonalCertificate = () => import(/* webpackChunkName: "attestation" */ '@/pages/attestation/personal-certificate'); // 个人认证

// ================== 后台通知管理模块 ==================
const InformEmail = () => import(/* webpackChunkName: "inform" */ '@/pages/inform/inform-email'); // 通知设置

// ================== 充值管理模块 ==================
const RechargeRecord = () => import(/* webpackChunkName: "recharge" */ '@/pages/recharge/recharge-record'); // 充值记录
const ConfirmedRecord = () => import(/* webpackChunkName: "recharge" */ '@/pages/recharge/confirmed-record'); // 待确认充值记录
const ConfirmedRefund = () => import(/* webpackChunkName: "recharge" */ '@/pages/recharge/confirmed-refund'); // 退汇记录

// ================== 商户管理模块 ==================
const TenantMessage = () => import(/* webpackChunkName: "commercial" */ '@/pages/commercial/tenant-message'); // 商户信息
const SellerInfoExamine = () => import(/* webpackChunkName: "commercial" */ '@/pages/commercial/sellerInfoExamine'); // 商户信息修改审核
const DeductionExamine = () => import(/* webpackChunkName: "commercial" */ '@/pages/commercial/deductionExamine'); // 加扣款审核
const BalanceEnquiry = () => import(/* webpackChunkName: "commercial" */ '@/pages/commercial/balance-enquiry'); // 账户及余额
const AssociatedAgent = () => import(/* webpackChunkName: "commercial" */ '@/pages/commercial/associated-agent'); // 关联代理商
const AssociatedProvider = () => import(/* webpackChunkName: "commercial" */ '@/pages/commercial/associated-provider'); // 关联服务商
const MerchantContract = () => import(/* webpackChunkName: "commercial" */ '@/pages/commercial/merchant-contract'); // 合同管理
const ContractRecycle = () => import(/* webpackChunkName: "commercial" */ '@/pages/commercial/contract-recycle'); // 合同回收站

// ================== 开票管理模块 ==================
const BillingRecord = () => import(/* webpackChunkName: "invoicing" */ '@/pages/invoicing/billing-record'); // 开票记录
const BillingCategory = () => import(/* webpackChunkName: "invoicing" */ '@/pages/invoicing/billing-category'); // 开票类目管理
const UnbilledRecord = () => import(/* webpackChunkName: "invoicing" */ '@/pages/invoicing/unbilled-record'); // 未开票数据
const InvoiceDetail = () => import(/* webpackChunkName: "invoicing" */ '@/pages/invoicing/invoice-detail'); // 未开票数据明细

// ================== 财务管理模块 ==================
const AgentFinance = () => import(/* webpackChunkName: "finance" */ '@/pages/Finance/agent-finance'); // 代理商财务管理
const MerchantFinance = () => import(/* webpackChunkName: "finance" */ '@/pages/Finance/merchant-finance'); // 商户财务管理

// ================== 监管管理模块 ==================
const SuperviseContract = () => import(/* webpackChunkName: "supervise" */ '@/pages/supervise/contract'); // 合同
const SuperviseCapital = () => import(/* webpackChunkName: "supervise" */ '@/pages/supervise/capital'); // 资金
const SuperviseTask = () => import(/* webpackChunkName: "supervise" */ '@/pages/supervise/task'); // 任务
const SuperviseInvoice = () => import(/* webpackChunkName: "supervise" */ '@/pages/supervise/invoice'); // 发票

// ================== 分润管理模块 ==================
const Closed = () => import(/* webpackChunkName: "share" */ '@/pages/share/closed'); // 商户分润
const ClosedAgent = () => import(/* webpackChunkName: "share" */ '@/pages/share/closed-agent'); // 代理商分润
const Settled = () => import(/* webpackChunkName: "share" */ '@/pages/share/settled'); // 季结分润

// ================== 提现管理模块 ==================
const WithdrawRecord = () => import(/* webpackChunkName: "withdraw" */ '@/pages/withdraw/record'); // 提现记录

// ================== 支付中心模块 ==================
const ApplicationRecord = () => import(/* webpackChunkName: "ipayment" */ '@/pages/ipayment/application-record'); // 申请记录
const AgainPayment = () => import(/* webpackChunkName: "ipayment" */ '@/pages/ipayment/again-payment'); // 重新支付
const ReturnRemittance = () => import(/* webpackChunkName: "ipayment" */ '@/pages/ipayment/return-remittance'); // 民生退汇
const RecordOrders = () => import(/* webpackChunkName: "ipayment" */ '@/pages/ipayment/record-orders'); // 挂单记录
const PayrollWorking = () => import(/* webpackChunkName: "ipayment" */ '@/pages/ipayment/payroll-working'); // 支付明细
const PrepaidFlow = () => import(/* webpackChunkName: "ipayment" */ '@/pages/ipayment/prepaid-flow'); // 民生预付流水
const CommissionRecord = () => import(/* webpackChunkName: "ipayment" */ '@/pages/ipayment/commission-record'); // 对公手续费记录
const TransferRecord = () => import(/* webpackChunkName: "ipayment" */ '@/pages/ipayment/transfer-record'); // 手续费转账记录
const QuestBook = () => import(/* webpackChunkName: "ipayment" */ '@/pages/ipayment/quest-book'); // 任务承接记录
const AccountPushList = () => import(/* webpackChunkName: "ipayment" */ '@/pages/ipayment/account_push_list.vue'); // 到账啦推送记录
const TaskFileReview = () => import(/* webpackChunkName: "ipayment" */ '@/pages/ipayment/taskFileReview'); // 验收文件审核

// ================== 退款管理模块 ==================
const RefundApplyFor = () => import(/* webpackChunkName: "refund" */ '@/pages/refund/refund-apply-for.vue'); // 退款申请
const RefundRecord = () => import(/* webpackChunkName: "refund" */ '@/pages/refund/refund-record.vue'); // 退款记录
const RefundToExamine = () => import(/* webpackChunkName: "refund" */ '@/pages/refund/refund-to-examine.vue'); // 退款审核

// ================== 税单管理模块 ==================
const IncomeDeclaration = () => import(/* webpackChunkName: "management" */ '@/pages/management/income-declaration'); // 个税申报
const DeclarationHistory = () => import(/* webpackChunkName: "management" */ '@/pages/management/declaration-history'); // 税单查询
const taxCalculate = () => import(/* webpackChunkName: "management" */ '@/pages/management/tax-calculate'); // 个税计算器
const taxCensus = () => import(/* webpackChunkName: "management" */ '@/pages/management/tax-census'); // 个税统计展示列表


// ================== 任务管理模块 ==================
const TaskConfig = () => import(/* webpackChunkName: "taskmanage" */ '@/pages/taskmanage/task-config'); // 任务类型配置
const TaskExample = () => import(/* webpackChunkName: "taskmanage" */ '@/pages/taskmanage/task-example'); // 任务示例列表

// ================== 密码管理模块 ==================
const PasswordPage = () => import(/* webpackChunkName: "cryptogram" */ '@/pages/cryptogram/password'); // 修改密码

// ================== 用户管理模块 ==================
const SystemUser = () => import(/* webpackChunkName: "usercontrol" */ '@/pages/usercontrol/system-User'); // 系统用户
const Logging = () => import(/* webpackChunkName: "viewlog" */ '@/pages/viewlog/logging'); // 日志记录

// ================== 系统设置模块 ==================
const CipherSettings = () => import(/* webpackChunkName: "system" */ '@/pages/system/cipher-settings'); // 密码配置
const AuthentSettings = () => import(/* webpackChunkName: "system" */ '@/pages/system/authent-settings'); // 认证配置
const EmailSettings = () => import(/* webpackChunkName: "system" */ '@/pages/system/email-settings'); // 预警邮箱配置
const PublicSettings = () => import(/* webpackChunkName: "system" */ '@/pages/system/public-settings'); // 公共配置
const FileSettings = () => import(/* webpackChunkName: "system" */ '@/pages/system/file-settings'); // 文件模板
const AgentSettings = () => import(/* webpackChunkName: "system" */ '@/pages/system/agent-settings'); // 代理商设置
const MerchantSettings = () => import(/* webpackChunkName: "system" */ '@/pages/system/merchant-settings'); // 商户设置
const PersonalSettings = () => import(/* webpackChunkName: "system" */ '@/pages/system/personal-settings'); // 个人设置
const RoleSettings = () => import(/* webpackChunkName: "system" */ '@/pages/system/role-settings'); // 角色设置
const SystemSettings = () => import(/* webpackChunkName: "system" */ '@/pages/system/system-settings'); // 系统设置
const PlatformSettings = () => import(/* webpackChunkName: "system" */ '@/pages/system/platform-settings'); // 平台设置
const PaycommonSettings = () => import(/* webpackChunkName: "system" */ '@/pages/system/paycommon-settings'); // 支付公共配置
const ServiceSettings = () => import(/* webpackChunkName: "system" */ '@/pages/system/service-settings'); // 支付账户配置
const PaymentSettings = () => import(/* webpackChunkName: "system" */ '@/pages/system/payment-settings'); // 支付分流设置
const AloneSettings = () => import(/* webpackChunkName: "system" */ '@/pages/system/alone-settings'); // 支付分流商户设置
const AlipayISV = () => import(/* webpackChunkName: "system" */ '@/pages/system/alipay-isv'); // 支付宝ISV设置
const AlipaySDK = () => import(/* webpackChunkName: "system" */ '@/pages/system/alipay-sdk'); // 支付通道SDK设置

// ================== 菜单管理模块 ==================
const SystemMenu = () => import(/* webpackChunkName: "menus" */ '@/pages/menus/system-menu'); // 系统菜单
const MerchantMenu = () => import(/* webpackChunkName: "menus" */ '@/pages/menus/merchant-menu'); // 商户菜单
const ServiceProviderMenu = () => import(/* webpackChunkName: "menus" */ '@/pages/menus/service-provider-menu'); // 服务商菜单
const AgentMenu = () => import(/* webpackChunkName: "menus" */ '@/pages/menus/agent-menu'); // 代理商菜单
const PersonalMenu = () => import(/* webpackChunkName: "menus" */ '@/pages/menus/personal-menu'); // 个人菜单

// ================== 商户合作模块 ==================
const CooperationPage = () => import(/* webpackChunkName: "cooperation" */ '@/pages/cooperation/cooperation'); // 商户合作查询

// ================== 客户经理管理模块 ==================
const CustomerBusiness = () => import(/* webpackChunkName: "customer-business" */ '@/pages/customerBusiness/customerBusiness'); // 客户经理管理

// ================== 注销管理模块 ==================
const CheckMark = () => import(/* webpackChunkName: "checkmark" */ '@/pages/checkmark/checkmark'); // 注销记录

// ================== 服务费管理模块 ==================
const ServiceDetails = () => import(/* webpackChunkName: "service-expense" */ '@/pages/service-expense/service-details'); // 服务费明细（系统）
const ServiceRecord = () => import(/* webpackChunkName: "service-expense" */ '@/pages/service-expense/service-record'); // 提现记录
const CashBalance = () => import(/* webpackChunkName: "service-expense" */ '@/pages/service-expense/cash-balance'); // 可提余额
const ServiceAccount = () => import(/* webpackChunkName: "service-expense" */ '@/pages/service-expense/service-account'); // 服务费账户
const ServiceCharges = () => import(/* webpackChunkName: "service-expense" */ '@/pages/service-expense/service-charges'); // 服务费明细（支付宝）

// ================== 下载中心模块 ==================
const DownloadRecord = () => import(/* webpackChunkName: "down-center" */ '@/pages/down-center/download-record'); // 下载中心

// ================== 操作日志模块 ==================
const OperationRecord = () => import(/* webpackChunkName: "operation-log" */ '@/pages/operation-log/operation-record'); // 操作记录

// ================== 数据中心模块 ==================
const BusinessStatement = () => import(/* webpackChunkName: "records-center" */ '@/pages/records-center/business-statement'); // 商户对账单
const VoluntarilyReconcile = () => import(/* webpackChunkName: "records-center" */ '@/pages/records-center/voluntarily-reconcile'); // 自动对账

// ================== 数据分析模块 ==================
const GrantRecord = () => import(/* webpackChunkName: "data-analysis" */ '@/pages/data-analysis/grant-record'); // 个人发放数据

// ================== 财务数据汇总模块 ==================
const FinanceRecord = () => import(/* webpackChunkName: "records-center" */ '@/pages/records-center/finance-record'); // 商户财务数据汇总
const FinanceAgent = () => import(/* webpackChunkName: "records-center" */ '@/pages/records-center/finance-agent'); // 代理商财务数据汇总
const TripartContrast = () => import(/* webpackChunkName: "records-center" */ '@/pages/records-center/tripart-contrast'); // 三方数据对比

// ================== 错误码管理模块 ==================
const ErrorList = () => import(/* webpackChunkName: "error-code" */ '@/pages/error-code/error-list.vue'); // 错误码列表

// ================== 记账本管理模块 ==================
const KeepAccount = () => import(/* webpackChunkName: "book-keep" */ '@/pages/book-keep/keep-account'); // 支付宝记账本

// ================== 路由配置 ==================
const router = new VueRouter({
  // 调试时注释掉下面的配置
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login-index'
    },
    {
      path: '/login-index',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      name: 'home',
      component: Index,
      meta: {
        title: "首页",
        canMultipleOpen: true
      },
      children: [
        {
          path: '/agent-message',
          name: 'agentMessage',
          component: AgentMessage,
          meta: {
            title: "代理商信息",
            canMultipleOpen: true
          }
        },
        {
          path: '/add-agent',
          name: 'addAgent',
          component: AddAgent,
          meta: {
            title: "新增代理商",
            canMultipleOpen: true
          }
        },
        {
          path: '/settle-change',
          name: 'settleChange',
          component: SettleChange,
          meta: {
            title: "代理商审核"
          }
        },
        {
          path: '/deductionExamine-agent',
          name: 'deductionExamineAgent',
          component: DeductionExamineAgent,
          meta: {
            title: "代理商加扣款审核"
          }
        },
        {
          path: '/associated-record',
          name: 'associatedrecord',
          component: AssociatedRecord,
          meta: {
            title: "代理商关联"
          }
        },
        {
          path: '/provider-message',
          name: 'providerMessage',
          component: ProviderMessage,
          meta: {
            title: "服务商信息",
            canMultipleOpen: true
          }
        },
        {
          path: '/add-provider',
          name: 'addProvider',
          component: AddProvider,
          meta: {
            title: "新增服务商",
            canMultipleOpen: true
          }
        },
        {
          path: '/personal-certificate',
          name: 'personalCertificate',
          component: PersonalCertificate,
          meta: {
            title: "个人认证",
            canMultipleOpen: true
          }
        },
        {
          path: '/inform-email',
          name: 'informEmail',
          component: InformEmail,
          meta: {
            title: "通知设置",
            canMultipleOpen: true
          }
        },
        {
          path: '/recharge-record',
          name: 'rechargeRecord',
          component: RechargeRecord,
          meta: {
            title: "充值记录",
            canMultipleOpen: true
          }
        },
        {
          path: '/confirmed-record',
          name: 'confirmedrecord',
          component: ConfirmedRecord,
          meta: {
            title: "待确认充值记录",
            canMultipleOpen: true
          }
        },
        {
          path: '/confirmed-refund',
          name: 'confirmedrefund',
          component: ConfirmedRefund,
          meta: {
            title: "退汇记录",
            canMultipleOpen: true
          }
        },
        {
          path: '/tenant-tessage',
          name: 'tenantMessage',
          component: TenantMessage,
          meta: {
            title: "商户信息",
            canMultipleOpen: true
          }
        },
        {
          path: '/sellerInfoExamine',
          name: 'sellerInfoExamine',
          component: SellerInfoExamine,
          meta: {
            title: '商户信息审核',
            canMultipleOpen: true
          }
        },
        {
          path: '/deductionExamine',
          name: 'deductionExamine',
          component: DeductionExamine,
          meta: {
            title: '加扣款审核',
            canMultipleOpen: true
          }
        },
        {
          path: '/balance-enquiry',
          name: 'balanceenquiry',
          component: BalanceEnquiry,
          meta: {
            title: "账户及余额",
            canMultipleOpen: true
          }
        },
        {
          path: '/associated-agent',
          name: 'associatedAgent',
          component: AssociatedAgent,
          meta: {
            title: "关联代理商",
            canMultipleOpen: true
          }
        },
        {
          path: '/associated-provider',
          name: 'associatedProvider',
          component: AssociatedProvider,
          meta: {
            title: "关联服务商",
            canMultipleOpen: true
          }
        },
        {
          path: '/merchant-contract',
          name: 'merchantContract',
          component: MerchantContract,
          meta: {
            title: "合同管理",
            canMultipleOpen: true
          }
        },
        {
          path: '/contract-recycle',
          name: 'contractRecycle',
          component: ContractRecycle,
          meta: {
            title: "合同回收站",
            canMultipleOpen: true
          }
        },
        {
          path: '/billing-record',
          name: 'billingRecord',
          component: BillingRecord,
          meta: {
            title: "开票记录",
            canMultipleOpen: true
          }
        },
        {
          path: '/billing-category',
          name: 'billingCategory',
          component: BillingCategory,
          meta: {
            title: "开票类目管理",
            canMultipleOpen: true
          }
        },
        {
          path: '/unbilled-record',
          name: 'unbilledrecord',
          component: UnbilledRecord,
          meta: {
            title: "未开票数据",
            canMultipleOpen: true
          }
        },
        {
          path: '/invoice-detail',
          name: 'invoicedetail',
          component: InvoiceDetail,
          meta: {
            title: "未开票数据明细",
            canMultipleOpen: true
          }
        },
        {
          path: '/agent-finance',
          name: 'agentFinance',
          component: AgentFinance,
          meta: {
            title: "代理商财务管理",
            canMultipleOpen: true
          }
        },
        {
          path: '/merchant-finance',
          name: 'merchantFinance',
          component: MerchantFinance,
          meta: {
            title: "商户财务管理",
            canMultipleOpen: true
          }
        },
        {
          path: '/contract',
          name: 'contract',
          component: SuperviseContract,
          meta: {
            title: "合同",
            canMultipleOpen: true
          }
        },
        {
          path: '/capital',
          name: 'capital',
          component: SuperviseCapital,
          meta: {
            title: "资金",
            canMultipleOpen: true
          }
        },
        {
          path: '/task',
          name: 'task',
          component: SuperviseTask,
          meta: {
            title: "任务",
            canMultipleOpen: true
          }
        },
        {
          path: '/invoice',
          name: 'invoice',
          component: SuperviseInvoice,
          meta: {
            title: "发票",
            canMultipleOpen: true
          }
        },
        {
          path: '/closed',
          name: 'closed',
          component: Closed,
          meta: {
            title: "商户分润",
            canMultipleOpen: true
          }
        },
        {
          path: '/closed-agent',
          name: 'closedagent',
          component: ClosedAgent,
          meta: {
            title: "代理商分润",
            canMultipleOpen: true
          }
        },
        {
          path: '/settled',
          name: 'settled',
          component: Settled,
          meta: {
            title: "季结分润",
            canMultipleOpen: true
          }
        },
        {
          path: '/record',
          name: 'record',
          component: WithdrawRecord,
          meta: {
            title: "提现记录",
            canMultipleOpen: true
          }
        },
        {
          path: '/application-record',
          name: 'applicationrecord',
          component: ApplicationRecord,
          meta: {
            title: "申请记录",
            canMultipleOpen: true
          }
        },
        {
          path: '/account_push_list',
          name: 'account_push_list',
          component: AccountPushList,
          meta: {
            title: "到账啦推送记录",
            canMultipleOpen: true
          }
        },
        {
          path: '/again-payment',
          name: 'againpayment',
          component: AgainPayment,
          meta: {
            title: "重新支付",
            canMultipleOpen: true
          }
        },
        {
          path: '/return-remittance',
          name: 'returnremittance',
          component: ReturnRemittance,
          meta: {
            title: "民生退汇",
            canMultipleOpen: true
          }
        },
        {
          path: '/record-orders',
          name: 'recordorders',
          component: RecordOrders,
          meta: {
            title: "挂单记录",
            canMultipleOpen: true
          }
        },
        {
          path: '/payroll-working',
          name: 'payrollworking',
          component: PayrollWorking,
          meta: {
            title: "支付明细",
            canMultipleOpen: true
          }
        },
        {
          path: '/prepaid-flow',
          name: 'prepaidflow',
          component: PrepaidFlow,
          meta: {
            title: "民生预付流水",
            canMultipleOpen: true
          }
        },
        {
          path: '/commission-record',
          name: 'commissionrecord',
          component: CommissionRecord,
          meta: {
            title: "对公手续费记录",
            canMultipleOpen: true
          }
        },
        {
          path: '/transfer-record',
          name: 'transferrecord',
          component: TransferRecord,
          meta: {
            title: "手续费转账记录",
            canMultipleOpen: true
          }
        },
        {
          path: '/quest-book',
          name: 'questbook',
          component: QuestBook,
          meta: {
            title: "任务承接记录",
            canMultipleOpen: true
          }
        },
        {
          path: '/task-config',
          name: 'taskConfig',
          component: TaskConfig,
          meta: {
            title: "任务类型配置",
            canMultipleOpen: true
          }
        },
        {
          path: '/task-example',
          name: 'taskExample',
          component: TaskExample,
          meta: {
            title: "任务示例列表",
            canMultipleOpen: true
          }
        },
        {
          path: '/TaskFileReview',
          name: 'TaskFileReview',
          component: TaskFileReview,
          meta: {
            title: "验收文件",
            canMultipleOpen: true
          }
        },
        {
          path: '/refund-apply-for',
          name: 'refund-apply-for',
          component: RefundApplyFor,
          meta: {
            title: "退款申请",
            canMultipleOpen: true
          }
        },
        {
          path: '/refund-record',
          name: 'refund-record',
          component: RefundRecord,
          meta: {
            title: "退款记录",
            canMultipleOpen: true
          }
        },
        {
          path: '/refund-to-examine',
          name: 'refund-to-examine',
          component: RefundToExamine,
          meta: {
            title: "退款审核",
            canMultipleOpen: true
          }
        },
        {
          path: '/income-declaration',
          name: 'income-declaration',
          component: IncomeDeclaration,
          meta: {
            title: "个税申报",
            canMultipleOpen: true
          }
        },
        {
          path: '/declaration-history',
          name: 'declaration-history',
          component: DeclarationHistory,
          meta: {
            title: "税单查询",
            canMultipleOpen: true
          }
        },
        {
          path: '/tax-calculate',
          name: 'tax-calculate',
          component: taxCalculate,
          meta: {
            title: "个税计算器",
            canMultipleOpen: true
          }
        },
        {
          path: '/tax-census',
          name: 'tax-census',
          component: taxCensus,
          meta: {
            title: "个税统计",
            canMultipleOpen: true
          }
        },
        {
          path: '/password',
          name: 'password',
          component: PasswordPage,
          meta: {
            title: "修改密码",
            canMultipleOpen: true
          }
        },
        {
          path: '/system-user',
          name: 'systemUser',
          component: SystemUser,
          meta: {
            title: "系统用户",
            canMultipleOpen: true
          }
        },
        {
          path: '/logging',
          name: 'logging',
          component: Logging,
          meta: {
            title: "日志记录",
            canMultipleOpen: true
          }
        },
        {
          path: '/cipher-settings',
          name: 'ciphersettings',
          component: CipherSettings,
          meta: {
            title: "密码配置",
            canMultipleOpen: true
          }
        },
        {
          path: '/authent-settings',
          name: 'authentsettings',
          component: AuthentSettings,
          meta: {
            title: "认证配置",
            canMultipleOpen: true
          }
        },
        {
          path: '/email-settings',
          name: 'emailsettings',
          component: EmailSettings,
          meta: {
            title: "预警邮箱配置",
            canMultipleOpen: true
          }
        },
        {
          path: '/public-settings',
          name: 'publicsettings',
          component: PublicSettings,
          meta: {
            title: "公共配置",
            canMultipleOpen: true
          }
        },
        {
          path: '/file-settings',
          name: 'filesettings',
          component: FileSettings,
          meta: {
            title: "文件模板",
            canMultipleOpen: true
          }
        },
        {
          path: '/agent-settings',
          name: 'agentSettings',
          component: AgentSettings,
          meta: {
            title: "代理商设置",
            canMultipleOpen: true
          }
        },
        {
          path: '/merchant-settings',
          name: 'merchantSettings',
          component: MerchantSettings,
          meta: {
            title: "商户设置",
            canMultipleOpen: true
          }
        },
        {
          path: '/personal-settings',
          name: 'personalSettings',
          component: PersonalSettings,
          meta: {
            title: "个人设置",
            canMultipleOpen: true
          }
        },
        {
          path: '/role-settings',
          name: 'roleSettings',
          component: RoleSettings,
          meta: {
            title: "角色设置",
            canMultipleOpen: true
          }
        },
        {
          path: '/system-settings',
          name: 'systemSettings',
          component: SystemSettings,
          meta: {
            title: "系统设置",
            canMultipleOpen: true
          }
        },
        {
          path: '/platform-settings',
          name: 'platformSettings',
          component: PlatformSettings,
          meta: {
            title: "平台设置",
            canMultipleOpen: true
          }
        },
        {
          path: '/paycommon-settings',
          name: 'paycommonsettings',
          component: PaycommonSettings,
          meta: {
            title: "支付公共配置",
            canMultipleOpen: true
          }
        },
        {
          path: '/service-settings',
          name: 'servicesettings',
          component: ServiceSettings,
          meta: {
            title: "支付账户配置",
            canMultipleOpen: true
          }
        },
        {
          path: '/payment-settings',
          name: 'paymentsettings',
          component: PaymentSettings,
          meta: {
            title: "支付分流设置",
            canMultipleOpen: true
          }
        },
        {
          path: '/alone-settings',
          name: 'alonesettings',
          component: AloneSettings,
          meta: {
            title: "支付分流商户设置"
          }
        },
        {
          path: '/alipay-isv',
          name: 'alipayISV',
          component: AlipayISV,
          meta: {
            title: "支付宝ISV设置"
          }
        },
        {
          path: '/alipay-sdk',
          name: 'alipaySDK',
          component: AlipaySDK,
          meta: {
            title: "支付通道SDK设置"
          }
        },
        {
          path: '/system-menu',
          name: 'systemMenu',
          component: SystemMenu,
          meta: {
            title: "系统菜单",
            canMultipleOpen: true
          }
        },
        {
          path: '/merchant-menu',
          name: 'merchantMenu',
          component: MerchantMenu,
          meta: {
            title: "商户菜单",
            canMultipleOpen: true
          }
        },
        {
          path: '/service-provider-menu',
          name: 'serviceProviderMenu',
          component: ServiceProviderMenu,
          meta: {
            title: "服务商菜单",
            canMultipleOpen: true
          }
        },
        {
          path: '/agent-menu',
          name: 'agentMenu',
          component: AgentMenu,
          meta: {
            title: "代理商菜单",
            canMultipleOpen: true
          }
        },
        {
          path: '/personal-menu',
          name: 'personalMenu',
          component: PersonalMenu,
          meta: {
            title: "个人菜单",
            canMultipleOpen: true
          }
        },
        {
          path: '/cooperationPage',
          name: 'cooperationPage',
          component: CooperationPage,
          meta: {
            title: "商务合作",
            canMultipleOpen: true
          }
        },
        {
          path: '/customerBusiness',
          name: 'customerBusiness',
          component: CustomerBusiness,
          meta: {
            title: "人员管理",
            canMultipleOpen: true
          }
        },
        {
          path: '/checkmark',
          name: 'checkmark',
          component: CheckMark,
          meta: {
            title: "注销记录",
            canMultipleOpen: true
          }
        },
        {
          path: '/service-details',
          name: 'servicedetails',
          component: ServiceDetails,
          meta: {
            title: "服务费明细（系统）",
            canMultipleOpen: true
          }
        },
        {
          path: '/service-record',
          name: 'servicerecord',
          component: ServiceRecord,
          meta: {
            title: "提现记录",
            canMultipleOpen: true
          }
        },
        {
          path: '/cash-balance',
          name: 'cashbalance',
          component: CashBalance,
          meta: {
            title: "可提余额",
            canMultipleOpen: true
          }
        },
        {
          path: '/service-account',
          name: 'serviceaccount',
          component: ServiceAccount,
          meta: {
            title: "服务费账户",
            canMultipleOpen: true
          }
        },
        {
          path: '/service-charges',
          name: 'servicecharges',
          component: ServiceCharges,
          meta: {
            title: "服务费明细（支付宝）",
            canMultipleOpen: true
          }
        },
        {
          path: '/download-record',
          name: 'downloadrecord',
          component: DownloadRecord,
          meta: {
            title: "下载中心"
          }
        },
        {
          path: '/operation-record',
          name: 'operationrecord',
          component: OperationRecord,
          meta: {
            title: "操作记录"
          }
        },
        {
          path: '/business-statement',
          name: 'businessStatement',
          component: BusinessStatement,
          meta: {
            title: "商户对账单"
          }
        },
        {
          path: '/voluntarily-reconcile',
          name: 'voluntarilyReconcile',
          component: VoluntarilyReconcile,
          meta: {
            title: "自动对账"
          }
        },
        {
          path: '/grant-record',
          name: 'grantRecord',
          component: GrantRecord,
          meta: {
            title: "个人发放数据"
          }
        },
        {
          // 商户数据汇总
          path: '/finance-record',
          name: 'financerecord',
          component: FinanceRecord,
          meta: {
            title: "商户数据汇总"
          }
        },
        {
          // 代理商数据汇总
          path: '/finance-agent',
          name: 'financeagent',
          component: FinanceAgent,
          meta: {
            title: "代理商数据汇总"
          }
        },
        {
          path: '/tripart-contrast',
          name: 'tripartContrast',
          component: TripartContrast,
          meta: {
            title: "三方数据对比"
          }
        },
        {
          path: '/error-list',
          name: 'error-list',
          component: ErrorList,
          meta: {
            title: "错误码列表",
            canMultipleOpen: true
          }
        },
        {
          path: '/keep-account',
          name: 'keepaccount',
          component: KeepAccount,
          meta: {
            title: "支付宝记账本"
          }
        }
      ]
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js